export default __webpack_public_path__ + "static/flag-cn-2d066ea4c76b6b49021b98c6834d2812.svg";